











import { BlogPost } from '@/models/blog-post.model';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Blog extends Vue {
  get blogPosts(): BlogPost[] {
    return this.$store.state.search.blogPosts.slice(0, 4);
  }
}
